import { render, staticRenderFns } from "./72.vue?vue&type=template&id=0b8a3399&scoped=true&"
import script from "./72.vue?vue&type=script&lang=js&"
export * from "./72.vue?vue&type=script&lang=js&"
import style0 from "./72.vue?vue&type=style&index=0&id=0b8a3399&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a3399",
  null
  
)

export default component.exports